import { tracking } from '@iwoca/frontend-tracking-library';
import {
    fetchGetFormalOffersCreditFacilityCommissionConsent,
    fetchPostFormalOffersCreditFacilityCommissionConsent
} from '@iwoca/lapi-client/edge';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { useStateKey } from '../../../../../../iwQueryClient/useStateKey';
import { maintainStateKey } from '../../../../../../iwRouter/LocationHelper';
import { useRequirementsProgress } from '../../useRequirementsProgress';

export function useCommissionConsent() {
    const stateKey = useStateKey();
    const history = useHistory();
    const { search } = useLocation();
    const queryClient = useQueryClient();
    const progress = useRequirementsProgress();
    const offerId = new URLSearchParams(search).get('offerId') ?? '';
    const amount = new URLSearchParams(search).get('amount') ?? '';

    const { data } = useQuery({
        queryKey: [
            'fetchGetFormalOffersCreditFacilityCommissionConsent',
            stateKey,
            offerId,
            amount
        ],
        queryFn: () =>
            fetchGetFormalOffersCreditFacilityCommissionConsent({
                stateKey,
                offerId,
                query: { cash_amount: Number(amount) }
            }),
        enabled: Boolean(offerId) && Boolean(amount),
        suspense: true
    });

    const { mutate: submitConsent, isLoading: isSubmitting } = useMutation({
        mutationFn: () =>
            fetchPostFormalOffersCreditFacilityCommissionConsent({
                stateKey,
                offerId,
                body: {
                    commission_consent_id: data!.commission_consent_id,
                    is_consent_given: true
                }
            }),
        onSuccess: () => {
            tracking.ampli.fundingRequirementsCommissionConsentCompleted({
                version: '2.0'
            });
            tracking.ampli.fundingRequirementCompleted({
                requirement: 'commission_consent',
                progress: { ...progress, commission_consent: true },
                version: '2.0'
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'fetchGetFormalOffersCreditFacilityCommissionConsent'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: ['fetchGetFundingRequirementsCreditFacility']
            });
            history.push(
                maintainStateKey({ pathname: '/funding-requirements/', search })
            );
        }
    });

    return { commissionDetails: data!, submitConsent, isSubmitting };
}
